var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 45,
    viewBox: "0 0 52 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V44.1262H42.78V35H33.5V18.2H25.5V9H16V0H0Z",
    fill: "#FEE3A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.936 18.2292H0V25.7052H15.936V18.2292Z",
    fill: "#A0522B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5139 18.2292H17.5779V25.7052H33.5139V18.2292Z",
    fill: "#A0522B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.936 36.6512H0V44.1272H15.936V36.6512Z",
    fill: "#A0522B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5139 36.6512H17.5779V44.1272H33.5139V36.6512Z",
    fill: "#A0522B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2199 36.6512H35.2839V44.1272H51.2199V36.6512Z",
    fill: "#A0522B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.936 0H0V7.476H15.936V0Z",
    fill: "#A0522B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2041 27.4972H9.26807V34.9732H25.2041V27.4972Z",
    fill: "#A0522B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96799 27.4972H0V34.9732H7.96799V27.4972Z",
    fill: "#A0522B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96799 8.9812H0V16.4572H7.96799V8.9812Z",
    fill: "#A0522B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M42.78 27.4972H26.845V34.9732H42.78V27.4972Z",
    fill: "#A0522B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5451 8.9812H9.61108V16.4572H25.5451V8.9812Z",
    fill: "#A0522B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7447 17.9621C37.3952 17.6404 37.4616 17.0094 36.8911 16.5608L26.5669 8.41104C25.9971 7.96172 25.3992 8.17304 25.2377 8.88055L21.7354 24.2324C21.5739 24.9399 21.9756 25.2565 22.6254 24.9348L36.7447 17.9621Z",
    fill: "#9CD9D6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M21.8774 24.9709L31.7307 12.4873L36.891 16.5615C37.4622 17.0108 37.3908 17.644 36.7432 17.9649L22.6261 24.9384C22.303 25.1043 22.0383 25.0971 21.8774 24.9709Z",
    fill: "#725439"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6503 6.96055C34.9359 7.18557 34.9864 7.60099 34.7592 7.88732L31.9854 11.4025L32.3359 12.2283C32.4304 12.4505 32.3965 12.7058 32.2472 12.8954L28.8467 17.2033C28.6202 17.4889 28.2055 17.5386 27.9199 17.3122C27.6343 17.0864 27.5845 16.671 27.8103 16.3847L30.9685 12.3841L30.618 11.559C30.5235 11.3376 30.5574 11.0801 30.7067 10.8919L33.7235 7.07017C33.95 6.7824 34.364 6.73409 34.6503 6.96055Z",
    fill: "#CAEBE5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5433 8.56318L36.5247 2.2518C36.7541 1.96188 37.1673 1.91788 37.4522 2.1429L38.7475 3.16487C39.0324 3.39061 39.0865 3.8017 38.8564 4.09235L33.8757 10.4037C33.6464 10.6937 33.2317 10.7376 32.9475 10.5133L31.6515 9.49139C31.3673 9.26565 31.3147 8.85311 31.5433 8.56318Z",
    fill: "#FED470"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3753 9.78353L34.9885 9.00696L32.6571 7.16603L32.0439 7.9426L34.3753 9.78353Z",
    fill: "#FF8000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6699 5.59909L38.2827 4.82214L35.9501 2.98239L35.3373 3.75934L37.6699 5.59909Z",
    fill: "#FF8000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M37 16.9182V44.13H0L23.6412 9.65015H24.7992L23.5826 15.1375L23.2883 16.4538L22.0717 21.9338L21.7981 23.1701L21.6074 24.03C21.5231 24.3925 21.5874 24.6544 21.7438 24.7821C21.7846 24.8092 21.8296 24.8356 21.8753 24.8488C21.9281 24.8694 21.9803 24.876 22.0389 24.876C22.1703 24.876 22.3196 24.8356 22.4904 24.7476L25.5957 23.1701H25.6036L28.0353 21.9338L36.4706 17.6556C36.5164 17.635 36.5557 17.6086 36.595 17.5808C36.8636 17.4083 37 17.1662 37 16.9182Z",
    fill: "#725439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.dd2d1149e8d594bd005a7f5ba1aecd54.svg";
export { ForwardRef as ReactComponent };